<h1>{{ 'MAIN_DASHBOARD.WS_DIRECTORY' | translate }}</h1>

<div class="content-container admin m-t-20">
  <div class="ui-g">
    <div class="ui-g-12">

      <div [formGroup]="notificationForm">
        <h3>{{ 'NOTIFICATIONS.HEADER' | translate }}</h3>
        <div class="ui-g">
          <div class="ui-g-4">
            <label>{{ 'NOTIFICATIONS.NOTIFICATION_LABEL' | translate }}</label>
            <p-dropdown [options]="notificationTypes"
                        placeholder="{{ 'NOTIFICATIONS.NOTIFICATION_PLACEHOLDER' | translate }}"
                        (onChange)="notificationChange($event)">
            </p-dropdown>
          </div>
        </div>
        <div *ngIf="selectedNotification">
          <div class="ui-g">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.SUBJECT_EN_LABEL' | translate }}</label>
              <input pInputText
                     formControlName="subject_en_GB">
            </div>
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.CONTENT_EN_LABEL' | translate }}</label>
              <p-editor formControlName="body_en_GB"
                        [style]="{'min-height':'150px'}">
              </p-editor>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.SUBJECT_FR_LABEL' | translate }}</label>
              <input pInputText
                     formControlName="subject_fr_FR">
            </div>

            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.CONTENT_FR_LABEL' | translate }}</label>
              <p-editor formControlName="body_fr_FR"
                        [style]="{'min-height':'150px'}">
              </p-editor>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.SUBJECT_ES_LABEL' | translate }}</label>
              <input pInputText
                     formControlName="subject_es_ES">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.CONTENT_ES_LABEL' | translate }}</label>
              <p-editor formControlName="body_es_ES"
                        [style]="{'min-height':'150px'}">
              </p-editor>
            </div>
          </div>
          <div class="ui-g" *ngIf="false">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.SUBJECT_ES_LABEL' | translate }}</label>
              <input pInputText
                     formControlName="subject_ar_AE">
            </div>
          </div>
          <div class="ui-g" *ngIf="false">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.CONTENT_ES_LABEL' | translate }}</label>
              <p-editor formControlName="body_ar_AE"
                        [style]="{'min-height':'150px'}">
              </p-editor>
            </div>
          </div>
          <div class="ui-g" *ngIf="false">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.SUBJECT_ES_LABEL' | translate }}</label>
              <input pInputText
                     formControlName="subject_ru_RU">
            </div>
          </div>
          <div class="ui-g" *ngIf="false">
            <div class="ui-g-12">
              <label>{{ 'NOTIFICATIONS.CONTENT_ES_LABEL' | translate }}</label>
              <p-editor formControlName="body_ru_RU"
                        [style]="{'min-height':'150px'}">
              </p-editor>
            </div>
          </div>
          <button pButton *gsShowIfHasPermission="['WSD_NOTIFICATIONS_UPDATE']"
                  class="ui-button-success m-b-30"
                  label="{{ 'NOTIFICATIONS.SAVE_BUTTON' | translate }}"
                  (click)="save()">
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<wsd-global-messages [life]="4000"></wsd-global-messages>
